import 'css-chunksrc/feature/check-item/CheckItemSplitModal.module.scss';export default {
  "container": "CheckItemSplitModal_container",
  "itemName": "CheckItemSplitModal_itemName",
  "partsLine": "CheckItemSplitModal_partsLine",
  "value": "CheckItemSplitModal_value"
};